import React, { Component } from 'react';

import {
  addRatingTemplate,
  updateRatingTemplate,
} from '../../services/apiService';

import LoadingCircleIcon from '../../icons/LoadingCircle';

class NewRatingTemplate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: '',
      parameters: [],
      loading: false,
      errorMessage: null,
    };
  }

  componentDidMount = () => {
    if (this.props.location.state) {
      const { id, title, parameters } = this.props.location.state;
      this.setState({
        id,
        title,
        parameters,
        editMode: true,
      });
    }
  };

  addParameter = () =>
    this.setState({
      parameters: [...this.state.parameters, {}],
    });

  removeParameter = (i) => {
    const parameters = this.state.parameters;
    parameters.splice(i, 1);

    this.setState({
      parameters,
    });
  };

  handleTitleInput = (e) => this.setState({ title: e.target.value });

  handleParamInput = (index) => (e) => {
    const parameters = this.state.parameters;
    let { name, value } = e.target;

    if (name === 'type' && value === 'number') {
      parameters[index].maxLength = parameters[index]?.maxLength || 5;
    }

    name === 'weight' && (value = Number(value));

    name === 'maxLength' && (value = Number(value));

    parameters[index][name] = value;
    this.setState({ parameters: parameters });
  };

  handleCheckbox = (e) => this.setState({ feedback: e.target.checked });

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ loading: true });

    const templateData = {
      title: this.state.title,
      parameters: this.state.parameters,
      feedback: this.state.feedback,
    };

    try {
      if (this.state.editMode) {
        await updateRatingTemplate({ ...templateData, id: this.state.id });
      } else {
        await addRatingTemplate(templateData);
      }
      this.props.history.goBack();
    } catch (err) {
      this.setState({
        errorMessage: this.state.editMode
          ? 'Updating Rating Template Failed!\n Please Try Again Later!!'
          : 'Adding New Rating Template Failed!\n Please Try Again Later!!',
        loading: false,
      });
    }
  };

  render() {
    return (
      <div className='font-medium text-gray-500'>
        <h1 className='text-gray-700 text-3xl font-bold mb-5'>
          Rating Templates
        </h1>
        <div className='bg-white p-8'>
          <h1 className='mb-6 font-semibold'>
            {this.state.editMode ? 'Update' : 'Add New'} Rating Templates
          </h1>

          <form onSubmit={this.handleSubmit} className='w-auto'>
            <label className='text-gray-400 block text-xs ml-2'>Title</label>
            <input
              type='text'
              onChange={this.handleTitleInput}
              value={this.state.title}
              className='w-full rounded-md border border-gray-300 focus:outline-none focus:border-blue-400 px-3 py-2'
              autoFocus
              required
            />

            <div className='mt-6 border-b border-gray-300' />
            {this.state.parameters.map((param, i) => (
              <div key={i} className='mt-4'>
                <div className='flex gap-2 items-center flex-wrap'>
                  <label className='text-gray-400 block text-xs mx-2 w-5'>
                    {i + 1} .
                  </label>
                  <input
                    type='text'
                    name='name'
                    onChange={this.handleParamInput(i)}
                    value={param.name}
                    className='max-w-6xl w-3/6 rounded-md border border-gray-300 focus:outline-none focus:border-blue-400 px-3 py-2'
                    required
                  />

                  <select
                    value={param?.type}
                    name='type'
                    required
                    onChange={this.handleParamInput(i)}
                    className='cursor-pointer border py-2 px-3 capitalize'
                  >
                    <option value='' selected disabled>
                      Choose Type
                    </option>

                    <option value='string'>text</option>
                    <option value='boolean'>yes / no</option>
                    <option value='number'>Rating</option>
                  </select>

                  {param?.type === 'number' && (
                    <input
                      type='number'
                      name='maxLength'
                      min={1}
                      max={10}
                      onChange={this.handleParamInput(i)}
                      defaultValue={param.maxLength}
                      placeholder='maximum length'
                      className='w-12 rounded-md border border-gray-300 focus:outline-none focus:border-blue-400 px-3 py-2'
                      required
                    />
                  )}

                  {param?.type === 'number' && (
                    <input
                      value={param?.weight}
                      type='number'
                      name='weight'
                      min={1}
                      max={100}
                      onChange={this.handleParamInput(i)}
                      defaultValue={1}
                      placeholder='weight'
                      className='w-12 rounded-md border border-gray-300 focus:outline-none focus:border-blue-400 px-3 py-2'
                      required
                    />
                  )}
                  {this.state.editMode && (
                    <button
                      onClick={() => this.removeParameter(i)}
                      type='button'
                      className='far fa-times-circle ml-4 text-gray-400 text-2xl'
                    />
                  )}
                </div>
                <input
                  type='text'
                  name='description'
                  onChange={this.handleParamInput(i)}
                  value={param.description}
                  placeholder='Description'
                  className='w-4/6 ml-11 mt-6 rounded-md border border-gray-300 focus:outline-none focus:border-blue-400 px-3 py-2'
                />
              </div>
            ))}

            <button
              onClick={this.addParameter}
              type='button'
              className='block text-blue-500 mt-4 focus:outline-none'
            >
              <i className='fas fa-plus mr-2' />
              <span className='font-medium'>Add Parameter</span>
            </button>

            <div className='mt-8 flex items-center gap-2 text-sm'>
              <input
                type='checkbox'
                onChange={this.handleCheckbox}
                className='w-5 h-5 cursor-pointer'
              />
              <span>Feedback text box</span>
            </div>

            <div className='flex gap-4 mt-6'>
              <button
                type='submit'
                className='w-1/2 bg-blue-500 text-white font-medium py-2 border border-blue-500 rounded'
              >
                {this.state.loading && (
                  <LoadingCircleIcon iconStyle='w-5 mr-2 text-white' />
                )}
                <span>
                  {this.state.editMode ? 'Update' : 'Add'} Rating Template
                </span>
              </button>

              <button
                onClick={() => this.props.history.goBack()}
                type='button'
                className='w-1/2 font-medium border border-gray-300 rounded py-2'
              >
                Cancel
              </button>
            </div>
          </form>

          {this.state.errorMessage && (
            <div className='mt-4 text-red-500 whitespace-pre-line'>
              {this.state.errorMessage}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default NewRatingTemplate;
